<div id="simple-page">
  <main>
    <div class="wrapper">
      <hyperkit-typography variant="h1" align="center" color="primary">
        Your Community access has ended</hyperkit-typography
      >
      <hyperkit-typography
        variant="body"
        size="md"
        align="center"
        color="secondary"
      >
        @if (isRevoked$ | async) {
          Reach out to your Intel 471 account team to discuss reactivating your
          account or upgrading to HUNTER Premium.
        } @else {
          Learn more about what HUNTER Premium can do for you and your
          organization.
        }
      </hyperkit-typography>
      <div class="container">
        <hyperkit-typography
          class="title"
          variant="h3"
          align="center"
          color="primary"
        >
          HUNTER Premium</hyperkit-typography
        >
        <hyperkit-typography
          variant="body"
          size="md"
          align="center"
          color="primary"
        >
          Elevate your threat hunting workbench with access to exclusive content
          and capabilities available only with HUNTER
          Premium.</hyperkit-typography
        >
        <div class="points">
          <div class="point">
            <hyperkit-icon
              class="icon"
              icon="check-circle"
              size="base"
              color="inherit"
            >
            </hyperkit-icon>
            <hyperkit-typography
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
              >Gain unrestricted access to Premium Hunt Packages for all
              security tools.
            </hyperkit-typography>
          </div>
          <div class="point">
            <hyperkit-icon
              class="icon"
              icon="check-circle"
              size="base"
              color="inherit"
            ></hyperkit-icon>
            <hyperkit-typography
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
              >Complete access to the hunt packages included in the Emerging
              Threats Collections.
            </hyperkit-typography>
          </div>
          <div class="point">
            <hyperkit-icon
              class="icon"
              icon="check-circle"
              size="base"
              color="inherit"
            >
            </hyperkit-icon>
            <hyperkit-typography
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
            >
              Direct line of communication with the Intel 471 Threat Hunt team
              via the Hunt Package Feedback Feature.
            </hyperkit-typography>
          </div>
          <div class="point">
            <hyperkit-icon
              class="icon"
              icon="check-circle"
              size="base"
              color="inherit"
            >
            </hyperkit-icon>
            <hyperkit-typography
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
            >
              Access to Threat Hunt Syncs with Intel 471 Threat Hunters as a
              part of the Customer Success Program.</hyperkit-typography
            >
          </div>
          <div class="point">
            <hyperkit-icon
              class="icon"
              icon="check-circle"
              size="base"
              color="inherit"
            >
            </hyperkit-icon>
            <hyperkit-typography
              variant="emphasized"
              size="sm"
              align="left"
              color="primary"
            >
              To plan, execute, report and manage the Hunt Packages, ask about
              access to the HUNTER Hunt Module.</hyperkit-typography
            >
          </div>
        </div>
        <div class="buttons">
          <hyperkit-button
            color="tertiary"
            [fullWidth]="true"
            text="Talk to Intel 471"
            (click)="talkToCyborg()"
          ></hyperkit-button>
        </div>
      </div>
      @if (!(isRevoked$ | async)) {
        <hyperkit-link
          (click)="openDialog()"
          variant="emphasized"
          size="sm"
          color="primary"
          text=" No thanks, just reactivate my Community access..."
        ></hyperkit-link>
      }
    </div>
  </main>
</div>
